import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toPng } from "html-to-image";
import { toast } from "sonner";
import { X, CaretLeft, CaretRight, DownloadSimple } from "@phosphor-icons/react";

export const Big = ({ children, color }) => (
  <div className="font-heading font-extrabold num leading-none" style={{ fontSize: "clamp(3.5rem,12vw,7rem)", color }}>{children}</div>
);
export const Label = ({ children }) => <div className="text-sm uppercase tracking-[0.25em] opacity-70 mb-4">{children}</div>;
export const Sub = ({ children }) => <div className="text-base sm:text-lg opacity-85 mt-4 max-w-md">{children}</div>;

export const plural = (n, [a, b, c]) => {
  const m10 = n % 10, m100 = n % 100;
  return m10 === 1 && m100 !== 11 ? a : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? b : c;
};

export const StoryViewer = ({ slides, shareName, testPrefix = "wrapped" }) => {
  const nav = useNavigate();
  const [idx, setIdx] = useState(0);
  const finalRef = useRef(null);

  const share = () => {
    if (!finalRef.current) return;
    toPng(finalRef.current, { pixelRatio: 2 }).then((url) => {
      const a = document.createElement("a");
      a.download = `${shareName}.png`;
      a.href = url;
      a.click();
      toast.success("Картинка сохранена — делитесь!");
    }).catch(() => toast.error("Не удалось сохранить картинку"));
  };

  const slide = slides[idx];
  return (
    <div className="fixed inset-0 z-[60] flex flex-col select-none" style={{ background: slide.bg }} data-testid={`${testPrefix}-page`}>
      <div className="flex gap-1 px-4 pt-[max(1rem,env(safe-area-inset-top))]">
        {slides.map((_, i) => (
          <div key={i} className="h-1 flex-1 rounded-full bg-white/15 overflow-hidden">
            <div className="h-full bg-white/80 transition-all duration-300" style={{ width: i <= idx ? "100%" : "0%", opacity: i === idx ? 1 : 0.6 }} />
          </div>
        ))}
      </div>
      <button onClick={() => nav(-1)} data-testid={`${testPrefix}-close`} className="absolute top-[max(1.6rem,env(safe-area-inset-top))] right-4 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"><X size={18} /></button>

      <div className="flex-1 flex flex-col items-center justify-center text-center px-8 fade-in overflow-y-auto" key={idx} data-testid={`${testPrefix}-slide-${slide.id}`}>
        {slide.render(finalRef)}
        {slide.share && (
          <button onClick={share} data-testid={`${testPrefix}-share-btn`}
            className="mt-6 flex items-center gap-2 px-6 py-3 rounded-full bg-amber-300 text-black text-sm font-bold hover:brightness-110 transition-all">
            <DownloadSimple size={17} weight="bold" /> Сохранить картинку
          </button>
        )}
      </div>

      <div className="flex items-center justify-between px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <button onClick={() => setIdx(Math.max(0, idx - 1))} disabled={idx === 0} data-testid={`${testPrefix}-prev`}
          className="p-3 rounded-full bg-white/10 disabled:opacity-30 hover:bg-white/20 transition-colors"><CaretLeft size={20} /></button>
        <span className="text-xs opacity-60 num">{idx + 1} / {slides.length}</span>
        <button onClick={() => setIdx(Math.min(slides.length - 1, idx + 1))} disabled={idx === slides.length - 1} data-testid={`${testPrefix}-next`}
          className="p-3 rounded-full bg-white/10 disabled:opacity-30 hover:bg-white/20 transition-colors"><CaretRight size={20} /></button>
      </div>
    </div>
  );
};
